
export enum Vendor_Types
{
   'resturants' = 461,
   'select' = 2
}